<template>
      <router-view/>
</template>

<script>
    export default {

        data() {
            return {

            }
        },
      computed: {

      }
    }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue